<span
  class="app-badge"
  [class.app-badge--success]="variant === 'success'">
  <ng-content></ng-content>
</span>
